// @flow

import _ from 'lodash';

import server from 'server2';
import type { Options, ClientInterface } from 'server2';

import { IClient } from '../api';

export type ClientOptions = {
	onUrlNormalize: (Array<string>) => Array<string>,
}

export default class Client implements IClient {
	_whenAppReady: Promise<void>;
	_server: ClientInterface;
	_options: ClientOptions;

	constructor (apiService: ClientInterface, params: ClientOptions) {
		const options = _.defaults(params, {
			onUrlNormalize: _.noop,
		});

		this._whenAppReady = server.ready();

		this._server = apiService;
		this._options = options;
	}

	post (urlParts: Array<string>, parameters: ?Options) {
		const url = this._options.onUrlNormalize(urlParts);

		return this._whenAppReady.then(() =>
			this._server.post(url, parameters || {})
		).then(
			res => res && res.responseJSON
		);
	}

	put (urlParts: Array<string>, parameters: ?Options) {
		const url = this._options.onUrlNormalize(urlParts);

		return this._whenAppReady.then(() =>
			this._server.put(url, parameters || {})
		).then(
			res => res && res.responseJSON
		);
	}


	del (urlParts: Array<string>, parameters: ?Options) {
		const url = this._options.onUrlNormalize(urlParts);

		return this._whenAppReady.then(() =>
			this._server.del(url, parameters || {})
		).then(
			res => res && res.responseJSON
		);
	}

	get (urlParts: Array<string>, parameters: ?Options) {
		const url = this._options.onUrlNormalize(urlParts);

		return this._whenAppReady.then(
			() => this._server.get(url, parameters || {})
		).then(
			res => res && res.responseJSON
		);
	}
}
